export default __webpack_public_path__ + "static/hodler@2x-f037dee2f8eb0b38657f8d1ee808a721.png";